// Indian currency formatter (₹ 1,00,00,000)
export const inr = (n) => {
  if (n === null || n === undefined || isNaN(n)) return '₹ 0';
  const x = Math.round(Number(n));
  const s = x.toString();
  let lastThree = s.substring(s.length - 3);
  const otherNumbers = s.substring(0, s.length - 3);
  if (otherNumbers !== '') lastThree = ',' + lastThree;
  return '₹ ' + otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
};

// Tight INR formatter used by HR, Contracts, Closeout — no space after ₹,
// integer rounding, sign aware, returns "—" for null/undefined (callers
// already coerce 0 → "₹0" on purpose for KPI tiles).
export const formatINR = (v, { dashIfNull = false } = {}) => {
  if (v === null || v === undefined) return dashIfNull ? '—' : '₹0';
  const n = Number(v);
  if (!Number.isFinite(n)) return dashIfNull ? '—' : '₹0';
  const sign = n < 0 ? '-' : '';
  return `${sign}₹${Math.abs(n).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
};

export const inrCompact = (n) => {
  if (!n) return '₹ 0';
  const num = Number(n);
  if (num >= 10000000) return `₹ ${(num / 10000000).toFixed(2)} Cr`;
  if (num >= 100000) return `₹ ${(num / 100000).toFixed(2)} L`;
  if (num >= 1000) return `₹ ${(num / 1000).toFixed(1)} K`;
  return `₹ ${num}`;
};

export const formatDate = (d) => {
  if (!d) return '—';
  try { return new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }); }
  catch { return d; }
};

// Always render attendance / punch times in IST (Asia/Kolkata)
// regardless of the device's local timezone. Important for the Android app
// where users abroad or on roaming may have a non-IST locale.
export const formatISTTime = (d) => {
  if (!d) return '—';
  try {
    return new Date(d).toLocaleTimeString('en-IN', {
      hour: '2-digit', minute: '2-digit',
      hour12: true, timeZone: 'Asia/Kolkata',
    });
  } catch { return ''; }
};

export const formatISTDateTime = (d) => {
  if (!d) return '—';
  try {
    return new Date(d).toLocaleString('en-IN', {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: true,
      timeZone: 'Asia/Kolkata',
    });
  } catch { return ''; }
};

export const statusColor = (s) => {
  const m = {
    Active: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
    Completed: 'bg-slate-100 text-slate-700 border border-slate-200',
    Delayed: 'bg-red-50 text-red-700 border border-red-200',
    Pending: 'bg-amber-50 text-amber-700 border border-amber-200',
    'In Progress': 'bg-teal-50 text-teal-700 border border-teal-200',
    Approved: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
    Submitted: 'bg-teal-50 text-teal-700 border border-teal-200',
    'Pending Approval': 'bg-amber-50 text-amber-700 border border-amber-200',
    Open: 'bg-red-50 text-red-700 border border-red-200',
    Closed: 'bg-slate-100 text-slate-600 border border-slate-200',
    Working: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
    Maintenance: 'bg-amber-50 text-amber-700 border border-amber-200',
    Delivered: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
    Hot: 'bg-red-50 text-red-700 border border-red-200',
    Warm: 'bg-amber-50 text-amber-700 border border-amber-200',
    Cold: 'bg-slate-100 text-slate-600 border border-slate-200',
    Low: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
    Medium: 'bg-amber-50 text-amber-700 border border-amber-200',
    High: 'bg-red-50 text-red-700 border border-red-200',
  };
  return m[s] || 'bg-slate-100 text-slate-700 border border-slate-200';
};
